import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/settings.actions';
import { AumicoSettingsService } from '../services/aumico-settings.service';
import { getDebug, getTag } from '../utils/debugUtil';

const filename =
    '/home/user/aumico-dev-env/frontend/aumico-proto-application/projects/aumico-lib-settings-fe/src/lib/effects/accounting-basis.effects.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);

@Injectable()
export class CurrencyEffects {
    constructor(private actions$: Actions, private service: AumicoSettingsService) {}

    getAllCurrency$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.currencyActions.getAllCurrency),
            mergeMap((action) => {
                return this.service.getAllCurrency().pipe(
                    map((response) => {
                        return fromActions.currencyActions.onGetAllCurrencySuccess({
                            payload: response,
                        });
                    }),
                    catchError((error) => {
                        return of(fromActions.currencyActions.onGetAllCurrencyFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );
}
